import axios from 'axios';

export interface ErrorResponse {
  errorCode: number;
  message: string;
}

// paramsSerializer
const customParamsSerializer = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item));
    } else {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};

export const chatCustomAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL_CHAT,
  timeout: 3000,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: 'Bearer req-cms',
    AppKey: 'req-cms'
  },
  paramsSerializer: customParamsSerializer
});

export const gamesCustomAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL_GAMES,
  timeout: 3000,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json'
  },
  paramsSerializer: customParamsSerializer
});
